import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {OrdiniVenditaStat} from '../../_models/OrdiniVenditaStat';

export interface BloccoOrdini {
  etichetta: string;
  conteggio: number;
  importo: number;
  percentuale: number;
  classe: string;
}

/** Feature 161 (B3): ordini clienti attivi, da consegnare, in preparazione e consegnati. */
@Component({
  selector: 'app-dashboard-ordini-clienti',
  templateUrl: './dashboard-ordini-clienti.component.html',
  styleUrls: ['../dashboard-widget.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule]
})
export class DashboardOrdiniClientiComponent {
  /** null senza errore = caricamento. */
  @Input()
  set stat(stat: OrdiniVenditaStat | null) {
    this._stat = stat;
    this.blocchi = blocchiDi(stat);
  }

  get stat(): OrdiniVenditaStat | null {
    return this._stat;
  }

  @Input() errore = false;

  /** Calcolati una volta per input, non a ogni change detection (vedi `DashboardStatoMacchineComponent`). */
  blocchi: BloccoOrdini[] = [];
  private _stat: OrdiniVenditaStat | null = null;
}

function blocchiDi(s: OrdiniVenditaStat | null): BloccoOrdini[] {
  if (!s) return [];
  const totale = s.daConsegnare + s.inPreparazione + s.consegnati;
  const blocco = (etichetta: string, conteggio: number, importo: number, classe: string): BloccoOrdini =>
    ({etichetta, conteggio, importo, classe, percentuale: totale > 0 ? conteggio / totale * 100 : 0});
  return [
    blocco('Da consegnare', s.daConsegnare, s.importoDaConsegnare, 'bg-red-400'),
    blocco('In preparazione', s.inPreparazione, s.importoInPreparazione, 'bg-amber-400'),
    blocco('Consegnati', s.consegnati, s.importoConsegnati, 'bg-teal-400')
  ];
}
